// extracted by mini-css-extract-plugin
export default {"input":"_1Bcpw_pC","label":"_3hGNtA0_"};